import { atoms } from "#/lib/atoms/atoms";
import queryKeys from "#/lib/query-keys";
import { fetchRequest } from "#/lib/stream-api";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import type { components } from "#/types.ts/swagger";

export const useMerchantLocations = (mid?: string) => {
  const currentMid = useAtomValue(atoms.mid);
  const { isLoading, data } = useSuspenseQuery<
    components["schemas"]["GetMerchantLocationsResponseDto"]
  >({
    queryKey: queryKeys.locations(mid || currentMid),
    queryFn: async ({ queryKey }) => {
      const mid = queryKey?.[1];
      if (!mid) return { locations: [] };

      return fetchRequest(`/location/merchant`, {
        method: "get",
        headers: {
          merchant_id: mid as string,
        },
      });
    },
  });

  return {
    data: data?.locations || [],
    loading: isLoading,
  };
};
